import { bridgeApiConfig, type BridgeRouteTypeMap } from 'bridge-functions/client'
import { backendClient } from '@/utils/backendClient'

export const bridgeApi = backendClient<BridgeRouteTypeMap>(bridgeApiConfig)
